import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { SiteVendor } from 'src/app/classes/models';
import { GenericObject } from 'src/app/interfaces/generic-object';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';
import { AssignSitesToVendorModalComponent } from 'src/app/modals/assign-sites-to-vendor-modal/assign-sites-to-vendor-modal.component';
import { ConfirmModalComponent } from 'src/app/modals/confirm-modal/confirm-modal.component';
import { SiteService } from 'src/app/services/site.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-vendor-site-assignment',
  templateUrl: './vendor-site-assignment.component.html',
  styleUrl: './vendor-site-assignment.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VendorSiteAssignmentComponent {
  constructor(
    private route: ActivatedRoute,
    private ToastService: ToastService,
    private ModalService: NgbModal,
    private SiteService: SiteService
  ) {
    this.route.paramMap.subscribe({
      next: (ParamMap) => {
        const CompanyId = Number(ParamMap.get('CompanyId'));
        const VendorId = Number(ParamMap.get('VendorId'));
        const ExemptVendorId = Number(ParamMap.get('ExemptVendorId'));
        const ClientRegisteredVendorId = Number(
          ParamMap.get('ClientRegisteredVendorId')
        );

        if (!CompanyId) {
          throw this.ToastService.addErrorToast(
            'Error',
            'Missing client information.',
            { returnError: true }
          );
        }

        this.CompanyId = CompanyId;

        Object.assign(this.SuppliedGridQuery, {
          Site: {
            options: { required: true },
            CompanyId
          }
        });

        if (VendorId) {
          this.VendorId = VendorId;
          Object.assign(this.SuppliedGridQuery, { VendorId });
        }

        if (ExemptVendorId) {
          this.ExemptVendorId = ExemptVendorId;
          Object.assign(this.SuppliedGridQuery, { ExemptVendorId });
        }

        if (ClientRegisteredVendorId) {
          this.ClientRegisteredVendorId = ClientRegisteredVendorId;
          Object.assign(this.SuppliedGridQuery, { ClientRegisteredVendorId });
        }
      }
    });
  }

  SuppliedGridQuery: GenericObject = {
    attributes: [
      'id',
      'SiteId',
      'VendorId',
      'ExemptVendorId',
      'ClientRegisteredVendorId'
    ]
  };
  reloadGrid: boolean = false;
  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['delete']
  };
  CompanyId: number | null = null;
  VendorId: number | null = null;
  ExemptVendorId: number | null = null;
  ClientRegisteredVendorId: number | null = null;

  actionEvent({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: SiteVendor;
  }) {
    const { id } = rowData;

    if (!id) {
      throw this.ToastService.addErrorToast('Error', 'Missing site data.', {
        returnError: true
      });
    }

    if (action === 'delete') {
      const { componentInstance, result } = this.ModalService.open(
        ConfirmModalComponent,
        { centered: true, size: 'md' }
      );
      Object.assign(componentInstance, {
        displayText: 'Are you sure you want to remove this vendor site?'
      });

      from(result).subscribe({
        next: (confirm) => {
          if (confirm) {
            this.SiteService.deleteSiteVendor(rowData).subscribe({
              next: () => {
                this.ToastService.addSuccessToast(
                  'Success',
                  'Successfully deleted vendor from site.'
                );
                this.reloadGrid = true;
              }
            });
          }
        }
      });
    }
  }

  addVendorToSites() {
    const { componentInstance, result } = this.ModalService.open(
      AssignSitesToVendorModalComponent,
      { centered: true, size: 'xl' }
    );
    Object.assign(componentInstance, {
      CompanyId: this.CompanyId,
      VendorId: this.VendorId,
      ExemptVendorId: this.ExemptVendorId,
      ClientRegisteredVendorId: this.ClientRegisteredVendorId
    });

    from(result).subscribe({
      next: () => (this.reloadGrid = true)
    });
  }
}
